import {
  DxButton
} from "devextreme-vue/button"
import {
  DxBox,
  DxItem
} from 'devextreme-vue/box'
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem
} from 'devextreme-vue/form'
import {
  DxDateBox
} from 'devextreme-vue/date-box'
import {
  DxPopup
} from 'devextreme-vue/popup'
import {
  DxLoadPanel
} from 'devextreme-vue/load-panel'
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxLookup,
  DxSorting,
  DxScrolling,
  DxSearchPanel,
  DxPaging
} from "devextreme-vue/data-grid"
import {
  DxSpeedDialAction,
  DxSelectBox
} from 'devextreme-vue'
import {
  DxTextArea
} from 'devextreme-vue/text-area'
import {
  DxScrollView
} from 'devextreme-vue/scroll-view'

import DxList from 'devextreme-vue/list'
import notify from 'devextreme/ui/notify'

import {
  shiftPlanService
} from '../../../services/shift-plan.service'

import config from 'devextreme/core/config'
import moment from "moment"

config({
  floatingActionButtonConfig: {
    icon: 'plus',
    position: {
      my: 'right bottom',
      at: 'right bottom',
      //of: '#gridBizContact',
      offset: '-16 -16',
    },
    label: '操作',
  }
})

export default {
  name: "shiftadjustment",
  data() {
    return {
      today: moment(),
      visibleLoadPanel: false,

      monthlyWorkerShift: {},

      selectedYearMonth: {},
      selectedYearMonthKeys: [],
      selectYearMonthPopupVisible: false,

      selectShiftPopupVisible: false,
      currentInputWorkerShift: {},

      submitPopupVisible: false,
      btnOKDisabled: true,

      submitMessage: "",

      selectableVsShifts: [],
    }
  },
  computed: {
    hasInputAndNotSubmited() {
      return this.$store.state.hasInputAndNotSubmited;
    },
    workerShifts() {
      if (!this.monthlyWorkerShift.hasOwnProperty("workerShifts")) {
        return [];
      }
      return this.monthlyWorkerShift.workerShifts;
    },
    selectableYearMonths() {

      if (!this.monthlyWorkerShift.hasOwnProperty("selectableYearMonths")) {
        return [];
      }

      let firstDayFormat = this.selectedYearMonth.hasOwnProperty("monthStart") ? this.selectedYearMonth.monthStart : (moment().startOf('month')).format("YYYY/MM/DD");

      let index = 1
      for (let yearMonth of this.monthlyWorkerShift.selectableYearMonths) {

        if (this.selectedYearMonthKeys.length <= 0 &&
          yearMonth.monthStart == firstDayFormat) {
          this.selectedYearMonthKeys = []
          this.selectedYearMonthKeys.push(index)
        }
        yearMonth.index = index
        index++
      }

      return this.monthlyWorkerShift.selectableYearMonths
    },
    selectableMaxYearMonth() {
      if (!this.monthlyWorkerShift.hasOwnProperty("selectableYearMonths")) {
        return {}
      }

      let tempYearMonth = {
        "monthStart": "1900-01-01"
      }

      for (let yearMonth of this.monthlyWorkerShift.selectableYearMonths) {
        if (moment(new Date(yearMonth.monthStart)) > moment(new Date(tempYearMonth.monthStart))) {
          tempYearMonth = yearMonth
        }
      }

      return tempYearMonth
    },
    selectableMinYearMonth() {
      if (!this.monthlyWorkerShift.hasOwnProperty("selectableYearMonths")) {
        return {}
      }

      let tempYearMonth = {
        "monthStart": "9999-12-31"
      }

      for (let yearMonth of this.monthlyWorkerShift.selectableYearMonths) {
        if (moment(new Date(yearMonth.monthStart)) < moment(new Date(tempYearMonth.monthStart))) {
          tempYearMonth = yearMonth
        }
      }

      return tempYearMonth
    },
    desiredShiftMsg() {
      return this.$store.state.constantDesiredShiftMsg
    },
    desiredShiftCode() {
      return this.$store.state.constantDesiredShiftCode
    },
    desiredShiftMinShiftDate() {
      if (!this.monthlyWorkerShift.hasOwnProperty("desiredShiftMinShiftDate")) {
        return "";
      }
      return moment(this.monthlyWorkerShift.desiredShiftMinShiftDate).format("YYYY/MM/DD");
    },
    desiredShiftMaxShiftDate() {
      if (!this.monthlyWorkerShift.hasOwnProperty("desiredShiftMaxShiftDate")) {
        return "";
      }
      return moment(this.monthlyWorkerShift.desiredShiftMaxShiftDate).format("YYYY/MM/DD");
    },
  },
  methods: {
    // 入力不可判定
    isEnterableColumn: function (workerShift) {

      let workingDay = moment(workerShift.workingDay).startOf('day');
      let today = moment().startOf('day');
      let diffWorkingDay = workingDay.diff(today, 'days');

      if (diffWorkingDay < 0) {
        return this.canSubmitWorkerTimeSheet(workerShift);
      } else {

        // 先にワークシートを提出する必要がある
        if(this.canSubmitWorkerTimeSheet(workerShift)){
          return true;
        }

        // 希望シフト調整中、確定中、通知中、入力不可
        if (workerShift.adjustStatusId == 2 || workerShift.adjustStatusId == 3 || workerShift.adjustStatusId == 4) return false;

        // 希望シフト期間外の空データの場合、入力不可
        if (workerShift.adjustStatusId == -1 && !workerShift.isShiftPeriod) return false;

         if ((workerShift.adjustStatusId == -1 || workerShift.adjustStatusId == 0 || workerShift.adjustStatusId == 1) && workerShift.desiredShiftJobId == null) return false;
        // 欠勤と年休の場合、入力不可
        if (this.isAbsence(workerShift)) return false;

        // 事務所要請 事務所対応中で変更不可
        if (workerShift.changeStatusId == 2 && workerShift.officeShiftChangeTreatStatusId == 2) return false;

        return true;
      }
    },
    // Mark列Css処理
    getCssClassColumnMark: function (row) {
      // 重点募集期間
      if (row.isImportantRecrutePeriod) return 'td-mark-shift-emphasis'

      // 希望シフト・シフト期間
      if (row.isShiftPeriod) return 'td-mark-shift-normal'

      if(row.displayMark != "") return 'td-mark-confirm'

      if (row.isToday) return 'td-today-mark'
      
      return 'td-mark'
    },
    // カレンダー表示Css処理
    getCssClassColumnCalendar: function (row) {

      if (this.isEnterableColumn(row)) {
        // 以下は入力可能のCss
        if (row.isToday && row.isSunday) {
          return 'td-today-calendar-sunday'
        } else if (row.isToday && !row.isSunday) {
          return 'td-today-calendar'
        } else if (!row.isToday && row.isSunday) {
          return 'td-calendar-sunday'
        } else if (!row.isToday && !row.isSunday) {
          return 'td-calendar'
        }
      } else {
        // 以下は入力不可のCss
        if (row.isToday && row.isSunday) {
          return 'td-today-calendar-sunday-light'
        } else if (row.isToday && !row.isSunday) {
          return 'td-today-calendar-light'
        } else if (!row.isToday && row.isSunday) {
          return 'td-calendar-sunday-light'
        } else if (!row.isToday && !row.isSunday) {
          return 'td-calendar-light'
        }
      }
    },
    // その他表示欄Css処理
    getCssClassColumn: function (row) {

      if (this.isEnterableColumn(row)) {
        // 以下は入力可能のCss
        if (row.isToday) {
          return 'td-today-normal'
        } else if (!row.isToday) {
          return 'td-normal'
        }
      } else {
        // 以下は入力不可のCss
        if (row.isToday) {
          return 'td-today-normal-light'
        } else if (!row.isToday) {
          return 'td-normal-light'
        }
      }
    },
    // 年休、欠勤の判定
    isAbsence(workerShift) {
      return workerShift.absenceType != null;
    },
    // ワークシート提出可能の判定workerTimeSheet
    canSubmitWorkerTimeSheet(workerShift) {

      let workingDay = moment(workerShift.workingDay).startOf('day');
      let today = moment().startOf('day');
      let diffWorkingDay = workingDay.diff(today, 'days');

      if (diffWorkingDay < -1)
        return workerShift.enableSubmitTimeSheet == 1 && workerShift.workerTimeSheetId == null;
      else if (diffWorkingDay == -1)
        return workerShift.enableSubmitTimeSheet == 1 && (workerShift.workerTimeSheetId == null || moment().hour() < parseInt(this.$store.state.constantClosingTime));
      else if (diffWorkingDay == 0)
        return workerShift.enableSubmitTimeSheet == 1;
      else if (diffWorkingDay > 0)
        return false;
    },
    // 事務所要請の回答可能判定
    canReplyOfficeShiftChange(workerShift) {
      //return workerShift.officeShiftChangeId != null && workerShift.changeStatusId == 2 && workerShift.officeShiftChangeTreatStatusId == 1;
      return workerShift.changeStatusId == 2 && workerShift.officeShiftChangeTreatStatusId == 1;
    },
    // 事務所要請の確認可能判定
    canConfirmOfficeShiftChange(workerShift) {
      //return workerShift.officeShiftChangeId != null && workerShift.changeStatusId == 2 && workerShift.officeShiftChangeTreatStatusId == 3;
      return workerShift.changeStatusId == 2 && workerShift.officeShiftChangeTreatStatusId == 3;
    },
    // ワーカー申請のキャンセル可能判定
    canCancelWorkerShiftChange(workerShift) {
      //return workerShift.workerShiftChangeId != null && workerShift.changeStatusId == 3 && workerShift.workerShiftChangeTreatStatusId == 1;
      return workerShift.changeStatusId == 3 && workerShift.workerShiftChangeTreatStatusId == 1;
    },
    // ワーカー申請の確認可能の判定
    canConfirmWorkerShiftChange(workerShift) {
      //return workerShift.workerShiftChangeId != null && workerShift.changeStatusId == 3 && workerShift.workerShiftChangeTreatStatusId == 2;
      return workerShift.changeStatusId == 3 && workerShift.workerShiftChangeTreatStatusId == 2;
    },
    // シフト変更制限日外の判定
    isWorkerShiftChangeUnlimitedPeriod(workerShift) {

      let workingDay = moment(workerShift.workingDay).startOf('day');
      let today = moment().startOf('day');
      let diffWorkingDay = workingDay.diff(today, 'days');

      let shiftChangeLimitDays = this.$store.state.constantShiftChangeLimitDays - 1;

      return shiftChangeLimitDays < diffWorkingDay; 
    },
    // 当日以前の判定
    isTodayOrAfter(workerShift) {

      let workingDay = moment(workerShift.workingDay).startOf('day');
      let today = moment().startOf('day');

      return workingDay.isSameOrAfter(today,'day');
    },
    //=======年月Popup画面処理===========
    onClickToShowSelectYearMonthPopup() {
      this.selectYearMonthPopupVisible = true;
    },
    onItemClickToChangeSelectYearMonth(e) {

      if (e.itemData == null) {
        if (moment(new Date(this.selectedYearMonth.monthStart)).format("YYYY/MM/DD") == e.itemData.monthStart) return;
      }

      this.selectedYearMonth = e.itemData;

      this.setYearMonthToStore();
      this.initShiftAdjustForm();

      this.selectYearMonthPopupVisible = false;
    },
    setYearMonthToStore() {
      this.$store.commit({
        type: 'setShiftSelectedYearMonth',
        yearMonth: this.selectedYearMonth
      });
    },
    //=======来月ボタン処理============
    onClickToGoNextMonth() {
      let currentMonthStart = moment(new Date(this.selectedYearMonth.monthStart))

      if (moment(new Date(this.selectableMaxYearMonth.monthStart)).diff(currentMonthStart, 'days') == 0) {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_NO_NEXT_MONTH, 'error');
        return;
      }

      let addMonthStartString = currentMonthStart.add(1, 'months').format("YYYY-MM-DD")

      for (let _temp of this.selectableYearMonths) {

        if (addMonthStartString == moment(new Date(_temp.monthStart)).format("YYYY-MM-DD")) {

          this.selectedYearMonth = _temp
          this.selectedYearMonthKeys = []
          this.selectedYearMonthKeys.push(this.selectedYearMonth.index)
          break
        }
      }

      this.setYearMonthToStore()
      this.initShiftAdjustForm()
    },
    //=======先月ボタン処理============
    onClickToGoLastMonth() {
      let currentMonthStart = moment(new Date(this.selectedYearMonth.monthStart))

      if (moment(new Date(this.selectableMinYearMonth.monthStart)).diff(currentMonthStart, 'days') == 0) {
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_NO_LAST_MONTH, 'error');
        return;
      }

      let minuteMonthStartString = currentMonthStart.add(-1, 'months').format("YYYY-MM-DD")

      for (let _temp of this.selectableYearMonths) {
        if (minuteMonthStartString == moment(new Date(_temp.monthStart)).format("YYYY-MM-DD")) {
          this.selectedYearMonth = _temp
          this.selectedYearMonthKeys = []
          this.selectedYearMonthKeys.push(this.selectedYearMonth.index)
          break
        }
      }

      this.setYearMonthToStore()
      this.initShiftAdjustForm()
    },
    //=======シフト選択Popup画面処理============
    onItemClickToChangeSelectVsShift(e) {

      if (e.itemData == null) return

      let selectedShift = e.itemData

      this.$store.commit({
        type: 'setHasInputAndNotSubmited',
        hasInputAndNotSubmited: true
      });

      if (selectedShift.shiftId > 0) {
        this.currentInputWorkerShift.shiftId = selectedShift.shiftId;
        this.currentInputWorkerShift.requestType = 1;
        this.currentInputWorkerShift.desiredShiftId = selectedShift.shiftId;
        this.currentInputWorkerShift.desiredWorkType = 1;
        this.currentInputWorkerShift.adjustShiftId = selectedShift.shiftId;
        this.currentInputWorkerShift.adjustWorkType = 1;
        if (this.currentInputWorkerShift.workContentI == null) {
          this.currentInputWorkerShift.workContentId = this.$store.state.worker.defaultWorkContentId;
        }
      } else if (selectedShift.shiftId < 0) {
        this.currentInputWorkerShift.shiftId = null;
        this.currentInputWorkerShift.requestType = -selectedShift.shiftId;
        this.currentInputWorkerShift.desiredShiftId = null;
        this.currentInputWorkerShift.desiredWorkType = -selectedShift.shiftId;
        this.currentInputWorkerShift.adjustShiftId = null;
        this.currentInputWorkerShift.adjustWorkType = -selectedShift.shiftId;
      } else {
        this.currentInputWorkerShift.shiftId = null;
        this.currentInputWorkerShift.requestType = null;
        this.currentInputWorkerShift.desiredShiftId = null;
        this.currentInputWorkerShift.desiredWorkType = null;
        this.currentInputWorkerShift.adjustShiftId = null;
        this.currentInputWorkerShift.adjustWorkType = null;
      }

      if (this.currentInputWorkerShift._State_ == 1) {
        this.currentInputWorkerShift._State_ = 4;
      }

      this.currentInputWorkerShift.adjustStatusId = 1;
      this.currentInputWorkerShift.changeStatusId = 1;

      this.currentInputWorkerShift.displayShiftText = selectedShift.shiftCode;
      this.currentInputWorkerShift.displayShiftTimeText = selectedShift.shiftId == 0 ? "" : selectedShift.shiftName;

      for (let workerShift of this.monthlyWorkerShift.workerShifts) {
        if (moment(workerShift.workingDay).diff(moment(this.currentInputWorkerShift.workingDay), 'days') == 0) {
          workerShift = this.currentInputWorkerShift;
          break;
        }
      }

      this.$store.commit({
        type: 'setShiftAdjustAllWorkerShifts',
        monthlyWorkerShifts: [this.monthlyWorkerShift]
      });

      this.selectShiftPopupVisible = false;
    },
    // 行操作処理
    onClickWorkerShiftRow(e) {

      let currentWorkerShift = e.data
      if (this.isAbsence(currentWorkerShift)) return;

      switch (currentWorkerShift.adjustStatusId) {
        case -1:
          this.inputWorkerShift(currentWorkerShift)
          break
        case 0:
          if (this.canSubmitWorkerTimeSheet(currentWorkerShift)) {
            this.$router.push({
              name: 'worker-time-sheet',
              params: {
                workingDay: moment(currentWorkerShift.workingDay).format("YYYY-MM-DD")
              }
            })
          }else{
            this.inputWorkerShift(currentWorkerShift)
          }
          break
        case 1:
          this.inputWorkerShift(currentWorkerShift)
          break
        case 2:
        case 3:
        case 4:
        case 5:
          this.submitWorkerShift(currentWorkerShift)
          break
      }
    },
    getEnabledSelectableVsShifts(workingDay) {

      let enabledSelectableVsShifts = []

      for (let shift of this.monthlyWorkerShift.selectableVsShifts) {
        
        if (workingDay >= shift.applicationStartDate)
        {
          var existsShiftInfo = this.getShiftInfoByShiftCode(enabledSelectableVsShifts, shift.shiftCode);

          if (existsShiftInfo.length > 0) {
            if (existsShiftInfo[0].shiftCode != "") {
              if (existsShiftInfo[0].applicationStartDate < shift.applicationStartDate) {
                //console.log(existsShiftInfo[0])
                enabledSelectableVsShifts = enabledSelectableVsShifts.filter(function(item){
                  if (item.shiftCode != existsShiftInfo[0].shiftCode) return true;
                });
              }
            }
          }
          enabledSelectableVsShifts.push(shift)
        }
      }

      return enabledSelectableVsShifts
    },
    getShiftInfoByShiftCode(vsShifts, shiftCode) {
      var itmes = vsShifts.filter(
          function(item) { return item.shiftCode == shiftCode }
      );
      return itmes;
    },
    deleteShiftInfoByShiftCode(vsShifts, shiftCode) {
      var itmes = vsShifts.filter(
          function(item) { return item.shiftCode == shiftCode }
      );
      itmes.remove();
    },
    inputWorkerShift(workerShift) {

      if (workerShift.desiredShiftJobId != null) {
        if (moment(workerShift.inputStartDate) <= moment().startOf('day') && moment().startOf('day') <= moment(workerShift.inputEndDate)) {
          this.currentInputWorkerShift = workerShift;

          this.selectableVsShifts = []

          var enabledSelectableVsShifts = this.getEnabledSelectableVsShifts(workerShift.workingDay)

          for (let shift of enabledSelectableVsShifts) {
              
            if(shift.shiftId == 0) {
              shift.shiftName = "（クリア）"
            }

            switch (this.currentInputWorkerShift.initialShiftOnlyFlag) {
              case 1:
                if ((shift.shiftId > 0 && shift.isDefaultShiftId == 1) || shift.shiftId <= 0) {
                  this.selectableVsShifts.push(shift)
                }
                break
              case 0:
                this.selectableVsShifts.push(shift)
                break
            }
          }

          this.selectShiftPopupVisible = true;
        }
      }
    },
    submitWorkerShift(workerShift) {

      if (this.canSubmitWorkerTimeSheet(workerShift)) {
        this.$router.push({
          name: 'worker-time-sheet',
          params: {
            workingDay: moment(workerShift.workingDay).format("YYYY-MM-DD")
          }
        })
        return;
      }

      // 今日以降の場合
      if (this.isTodayOrAfter(workerShift)) {
        switch (workerShift.changeStatusId) {
          case 0:
            // ワーカー申請提出可能な期間
            if (this.isWorkerShiftChangeUnlimitedPeriod(workerShift)) {
              // ワーカー申請 申請
              this.$router.push({
                name: 'worker-shift-change',
                params: {
                  workingDay: moment(workerShift.workingDay).format("YYYY-MM-DD")
                }
              });
            }else{ // ワーカー申請提出不可な期間
              this.showMessage(this.$store.state.constantShiftChangeLimitDays + process.env.VUE_APP_BASE_MESSAGE_CAN_NOT_CHANGE, 'error');
            }
            break;
          case 2:
            // 事務所変更 回答/確認
            if (this.canReplyOfficeShiftChange(workerShift) || this.canConfirmOfficeShiftChange(workerShift)) {
              this.$router.push({
                name: 'office-shift-change-job',
                params: {
                  workingDay: moment(workerShift.workingDay).format("YYYY-MM-DD")
                }
              });
            }
            break;
          case 3:
            // ワーカー申請 取消/確認
            if (this.canCancelWorkerShiftChange(workerShift) || this.canConfirmWorkerShiftChange(workerShift)) {
              this.$router.push({
                name: 'worker-shift-change',
                params: {
                  workingDay: moment(workerShift.workingDay).format("YYYY-MM-DD")
                }
              });
            }
            break;
        }
      }
    },
    //=======データリフレッシュ処理=======
    onClickRefreshData() {
      this.$store.commit({
        type: 'setHasInputAndNotSubmited',
        hasInputAndNotSubmited: false
      });

      this.initShiftAdjustForm(true)
    },
    //=======提出ボタン表示制御=======
    onClickToShowSubmitPopup() {
      this.submitPopupVisible = true
    },
    //=======提出処理=======
    onClickSubmitWorkerShift() {
      this.visibleLoadPanel = true

      let desiredShiftWorkers = []
      let workerShifts = []

      for (let monthlyWorkerShift of this.$store.state.shiftAdjustAllWorkerShifts) {
        if (moment(new Date(monthlyWorkerShift.yearMonth)) >= moment().startOf('month')) {
          let _desiredShiftJobIds = [];
          for (let workerShift of monthlyWorkerShift.workerShifts) {

            if (workerShift._State_ == 2 || workerShift._State_ == 4) {

              if (workerShift.shiftId == null && workerShift.requestType == null) {

                workerShift.requestType = this.desiredShiftCode
                workerShift.desiredWorkType = this.desiredShiftCode
                workerShift.adjustWorkType = this.desiredShiftCode
              }

              workerShift.adjustUserId = parseInt(this.$store.state.constantAppUpdateUserId);

              workerShifts.push(workerShift);

              let isPush = true;
              for (let desiredShiftJobId of _desiredShiftJobIds) {
                if (workerShift.desiredShiftJobId == desiredShiftJobId) {
                  isPush = false;
                  break;
                }
              }
              if (isPush) {
                _desiredShiftJobIds.push(workerShift.desiredShiftJobId);
              }
            }
          }

          for (let desiredShiftWorker of monthlyWorkerShift.desiredShiftWorkers) {
            for (let desiredShiftJobId of _desiredShiftJobIds) {
              if (desiredShiftWorker.desiredShiftJobId == desiredShiftJobId) {
                desiredShiftWorker.message = this.submitMessage;
                desiredShiftWorker.responseStatusId = 2;
                desiredShiftWorker.responseDateTime = moment().format("YYYY-MM-DD ");
                desiredShiftWorker._State_ = 4;
                desiredShiftWorkers.push(desiredShiftWorker);
                break;
              }
            }
          }
        }
      }

      //提出のワーカーシフトには内容がない場合、提出のAPIを呼び出さないで、メッセージを出す
      if(workerShifts.length == 0 && desiredShiftWorkers.length == 0){
        this.visibleLoadPanel = false;

        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_NO_NECESSARY_SUBMIT_WORKER_SHIFT, 'error');

        return
      }

      shiftPlanService.submitDesiredShifts(workerShifts, desiredShiftWorkers)
        .then(success => {

          if (success.messageType == 1) {

            this.showMessage(success.message, 'success');
            this.submitMessage = "";

            this.$store.commit({
              type: 'setHasInputAndNotSubmited',
              hasInputAndNotSubmited: false
            });

            this.initShiftAdjustForm(true);

            this.submitPopupVisible = false;
          } else {
            this.showMessage(success.message, 'error');
          }

          this.visibleLoadPanel = false;

        }).catch((errors) => {

          console.log(errors);

          this.visibleLoadPanel = false;
        })
    },
    //=======初期化処理=======
    initShiftAdjustForm(isRefresh = false) {

      if (!this.$store.state.shiftAdjustSelectedYearMonth.hasOwnProperty("yearMonth")) {
        this.selectedYearMonth = {
          "yearMonth": moment().format("YYYY年MM月"),
          "monthStart": moment().startOf('month').format("YYYY/MM/DD"),
          "monthEnd": moment().endOf('month').format("YYYY/MM/DD")
        };
        this.setYearMonthToStore();
      } else {
        this.selectedYearMonth = this.$store.state.shiftAdjustSelectedYearMonth;
      }

      let monthlyWorkerShiftsFromStore = this.getMonthlyWorkerShiftsFromStore(isRefresh);
      if (monthlyWorkerShiftsFromStore.length != 0) {
        this.monthlyWorkerShift = monthlyWorkerShiftsFromStore;
        this.btnOKDisabled = !this.isMonthlyWorkerShiftCanSubmit();
      } else {
        this.getMonthlyWorkerShiftsFromUrl();
      }
    },
    getMonthlyWorkerShiftsFromStore(isRefresh) {
      let monthlyWorkerShifts = [];

      // リフレッシュの場合、Nullを返す、強制的にAPIを再度呼び出し
      if (isRefresh) return monthlyWorkerShifts;

      // ストアの中身をチェック
      for (let _monthlyWorkerShifts of this.$store.state.shiftAdjustAllWorkerShifts) {
        if (moment(new Date(_monthlyWorkerShifts.yearMonth)).diff(moment(new Date(this.selectedYearMonth.monthStart)), 'days') == 0) {
          monthlyWorkerShifts = _monthlyWorkerShifts;
        }
      }

      // ストアの中に該当月のデータが存在しない場合、空を戻し、APIでデータを取ることにする
      if (monthlyWorkerShifts.length == 0) return [];

      // 検索の時間は当日と一日以上の差がある場合、空を戻し、APIでデータを取ることにする
      if (moment(new Date(monthlyWorkerShifts.queryDateTime)).diff(moment(), 'days') >= 1) {
        return [];
      }

      // monthlyWorkerShiftsを戻す
      return monthlyWorkerShifts;
    },
    getMonthlyWorkerShiftsFromUrl() {

      let workingDayFrom, workingDayTo = null;

      if (moment(new Date(this.selectedYearMonth.monthStart)) >= moment().startOf('month')) {
        workingDayFrom = moment().startOf('month').format("YYYY-MM-DD");
        workingDayTo = null;
      } else {
        workingDayFrom = moment(new Date(this.selectedYearMonth.monthStart)).format("YYYY-MM-DD");
        workingDayTo = moment(new Date(this.selectedYearMonth.monthEnd)).format("YYYY-MM-DD");
      }

      this.visibleLoadPanel = true;

      shiftPlanService.getWorkerShifts(workingDayFrom, workingDayTo)
        .then(success => {

          if (success.messageType == 1) {

            let monthlyWorkerShifts = success.content

            if (moment(new Date(this.selectedYearMonth.monthStart)) >= moment().startOf('month')) {
              this.confirmWorkerShifts(monthlyWorkerShifts);
            }

            // storeにデータを保存する
            this.$store.commit({
              type: 'setShiftAdjustAllWorkerShifts',
              monthlyWorkerShifts: monthlyWorkerShifts
            })

            // storeから、データをセットする
            this.monthlyWorkerShift = this.getMonthlyWorkerShiftsFromStore(false);

            //提出ボタンの使用可否
            this.btnOKDisabled = !this.isMonthlyWorkerShiftCanSubmit();

          } else {
            this.showMessage(success.message, 'error');
          }
        }).catch((errors) => {
          console.log(errors);
        }).finally(() => {
          this.visibleLoadPanel = false;
        })
    },
    confirmWorkerShifts(monthlyWorkerShifts) {
      let workerShifts = []

      for (let monthlyWorkerShift of monthlyWorkerShifts) {

        for (let workerShift of monthlyWorkerShift.workerShifts) {
          // if (workerShift.adjustStatusId == 0 || workerShift.adjustStatusId == 3 || workerShift.adjustStatusId == 4) {
          if (workerShift.adjustStatusId == 3 || workerShift.adjustStatusId == 4) {

            workerShift.changeStatusId = 0
            workerShift.adjustStatusId = 5
            workerShift._State_ = 4

            workerShifts.push(workerShift)
          }
        }
      }

      if (workerShifts.length != 0) {
        shiftPlanService.confirmDesiredShifts(workerShifts)
          .then(success => {

            if (success.messageType == 1) {
              this.initShiftAdjustForm(true)
            } else {
              this.showMessage(success.message, 'error');
            }

          }).catch((errors) => {
            console.log(errors)
          })
      }
    },
    isMonthlyWorkerShiftCanSubmit() {

      if (moment(this.monthlyWorkerShift.desiredShiftMaxShiftDate).year() == moment(new Date(this.selectedYearMonth.monthStart)).year() &&
        moment(this.monthlyWorkerShift.desiredShiftMaxShiftDate).month() == moment(new Date(this.selectedYearMonth.monthStart)).month() &&
        this.monthlyWorkerShift.desiredShiftWorkers.length != 0
        ) {
        return true;
      }
      return false;
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    },
  },
  mounted() {
    this.initShiftAdjustForm();
  },
  watch: {
    '$route': 'initShiftAdjustForm'
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxLookup,
    DxSorting,
    DxScrolling,
    DxSearchPanel,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxBox,
    DxItem,
    DxButton,
    DxLoadPanel,
    DxDateBox,
    DxSpeedDialAction,
    DxSelectBox,
    DxPopup,
    DxList,
    DxTextArea,
    DxScrollView,
    DxPaging,
  }
}